import { OcpsPolicyFeature, PrivacyPolicySettingId } from '../store/schema/OutlookCloudPolicyTypes';
import type { OutlookCloudPolicySettingId } from '../store/schema/OutlookCloudPolicyTypes';

export const settingIdToFeature: Record<OutlookCloudPolicySettingId, OcpsPolicyFeature> = {
    [PrivacyPolicySettingId.OptionalConnectedExperiences]: OcpsPolicyFeature.Privacy,
    [PrivacyPolicySettingId.ConnectedOfficeExperiences]: OcpsPolicyFeature.Privacy,
    // Beware of the typo "Anlayzing" — this is how the server stores it
    [PrivacyPolicySettingId.OfficeExperiencesAnalyzingContent]: OcpsPolicyFeature.Privacy,
    [PrivacyPolicySettingId.OfficeExperiencesDownloadingContent]: OcpsPolicyFeature.Privacy,
};
